import apiFactory from './api';

export default apiFactory();
